import PropTypes from 'prop-types';

import { useIntl } from 'react-intl';

import Grid from '@material-ui/core/Grid';

import { TextLabel, Textfield } from 'components/common';

import { PASSWORD_MAX_LENGTH } from 'settings/constants/common';

const ResetPasswordForm = ({ newPassword, newPasswordConfirmation, handleChange }) => {
  const { formatMessage } = useIntl();
  return (
    <Grid container spacing={1} alignItems="center" className="form-spacing">
      <Grid item xs={12} sm={5}>
        <TextLabel
          hasIcon
          isAssetIcon
          className="ml2"
          label={formatMessage({ id: 'selfUnlock.modal.container.resetPassword.password' })}
          tooltipTitle={formatMessage({ id: 'selfUnlock.modal.container.resetPassword.passwordTooltip' })}
        />
      </Grid>
      <Grid item xs={12} sm={7}>
        <Textfield
          id="newPassword"
          type="password"
          value={newPassword}
          autocomplete="new-password"
          onChange={e => handleChange('newPassword', e.target.value)}
          placeholder={formatMessage({ id: 'selfUnlock.modal.container.resetPassword.passwordPlaceholder' })}
          maxLength={PASSWORD_MAX_LENGTH}
        />
      </Grid>
      <Grid item xs={12} sm={5}>
        <TextLabel
          hasIcon
          isAssetIcon
          className="ml2"
          label={formatMessage({ id: 'selfUnlock.modal.container.resetPassword.confirmPassword' })}
          tooltipTitle={formatMessage({ id: 'selfUnlock.modal.container.resetPassword.confirmPasswordTooltip' })}
        />
      </Grid>
      <Grid item xs={12} sm={7}>
        <Textfield
          type="password"
          autocomplete="new-password"
          id="newPasswordConfirmation"
          value={newPasswordConfirmation}
          onChange={e => handleChange('newPasswordConfirmation', e.target.value)}
          placeholder={formatMessage({ id: 'selfUnlock.modal.container.resetPassword.confirmPasswordPlaceholder' })}
          maxLength={PASSWORD_MAX_LENGTH}
        />
      </Grid>
    </Grid>
  );
};

ResetPasswordForm.propTypes = {
  newPassword: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  newPasswordConfirmation: PropTypes.string.isRequired,
};

export default ResetPasswordForm;
